import React, { useEffect } from "react";
import { useGlobal } from "reactn";
import BillingOverview from "./BillingOverview";

interface PlusProps {
  setPage: (page: string) => void;
}

const Plus: React.FC<PlusProps> = ({ setPage }) => {
  const [loggingIn] = useGlobal("loggingIn");

  useEffect(() => {
    setPage("PLUS & Billing");
  }, []);

  if (loggingIn) {
    return (
      <div className="settings-route-page settings_premium">
        <div className="spinthatshit-loader">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="settings-route-page settings_premium">
      <BillingOverview />
    </div>
  );
};

export default Plus;
